import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CreatePluginListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePluginListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overview"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPluginListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"overview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overview"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CreatePluginListing","document":CreatePluginListingDocument}} as const;
export type CreatePluginListingMutationVariables = Types.Exact<{
  description: Types.Scalars['String']['input'];
  idPlugin: Types.Scalars['ID']['input'];
  locale: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
  overview: Types.Scalars['String']['input'];
}>;


export type CreatePluginListingMutation = (
  { __typename: 'Mutation' }
  & { createPluginListing?: Types.Maybe<(
    { __typename: 'Plugin_Listing' }
    & Pick<Types.Plugin_Listing, 'description' | 'locale' | 'name' | 'overview'>
  )> }
);

export type CreatePluginListingMutationFn = Apollo.MutationFunction<
  CreatePluginListingMutation,
  CreatePluginListingMutationVariables
>;

/**
 * __useCreatePluginListingMutation__
 *
 * To run a mutation, you first call `useCreatePluginListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePluginListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPluginListingMutation, { data, loading, error }] = useCreatePluginListingMutation({
 *   variables: {
 *      description: // value for 'description'
 *      idPlugin: // value for 'idPlugin'
 *      locale: // value for 'locale'
 *      name: // value for 'name'
 *      overview: // value for 'overview'
 *   },
 * });
 */
export function useCreatePluginListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePluginListingMutation,
    CreatePluginListingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePluginListingMutation,
    CreatePluginListingMutationVariables
  >(CreatePluginListingDocument, options);
}
export type CreatePluginListingMutationHookResult = ReturnType<
  typeof useCreatePluginListingMutation
>;
export type CreatePluginListingMutationResult =
  Apollo.MutationResult<CreatePluginListingMutation>;
export type CreatePluginListingMutationOptions = Apollo.BaseMutationOptions<
  CreatePluginListingMutation,
  CreatePluginListingMutationVariables
>;
